import { render, staticRenderFns } from "./WordCardHistory.vue?vue&type=template&id=774adeb4&scoped=true"
import script from "./WordCardHistory.vue?vue&type=script&lang=js"
export * from "./WordCardHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774adeb4",
  null
  
)

export default component.exports